import {
  MatomoProvider as MatomoTrackerProvider,
  createInstance,
} from '@jonkoops/matomo-tracker-react';

const instance = createInstance({
  urlBase: 'https://matomo.wecompair.eu/',
  siteId: window.__RUNTIME_CONFIG__?.REACT_APP_MATOMO_MONITORING_SITE_ID || -1,
});

export const MatomoProvider = ({ children }) => {
  return (
    <MatomoTrackerProvider value={instance}>{children}</MatomoTrackerProvider>
  );
};
